import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';
import { Pic_PROVIDER_A, Pic_PROVIDER_B, Pic_LOCATION } from '~/tenants/pic/vars';

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone and home address live in ./providers.server.ts and are merged
 * into these same objects on the server (tenants/providers.server.ts).
 */
const PIC_PROVIDER_DATA_PUBLIC: Record<string, ProviderPublic<ProviderStaticConfig>> = {
  [Pic_PROVIDER_A]: {
    first: 'Provider',
    last: 'A',
    headshot: 'avatar.jpg',
    location: Pic_LOCATION,
  },
  [Pic_PROVIDER_B]: {
    first: 'Provider',
    last: 'B',
    headshot: 'avatar.jpg',
    location: Pic_LOCATION,
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const PIC_PROVIDER_DATA = PIC_PROVIDER_DATA_PUBLIC as Record<string, ProviderStaticConfig>;
